// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"829da38a","239":"d247834a","732":"21b67d93"}[chunkId] + ".chunk.js";
};